import { Banner, Text } from '@loadsmart/miranda-react'

import { type Carrier } from '../../domain/Shipment'
import { useShipmentAnalytics } from '../hooks/useShipmentAnalytics'

export function OpenDockSignUpBanner({ shipmentCarrier }: { shipmentCarrier: Carrier }) {
  const { track } = useShipmentAnalytics()

  return (
    <Banner variant="warning" dismissible={false}>
      <Banner.Title>Improve your experience</Banner.Title>
      <Banner.Description>
        Your email isn't connected to Opendock yet. This means facilities won't easily access your
        info:
        <br />
        <Text variant="body-md-bold">
          {shipmentCarrier.name}
          <br /> MC {shipmentCarrier.mc} • DOT {shipmentCarrier.dot} {shipmentCarrier.email}
        </Text>
        <br />
        You can sign up later and proceed for now without an account.
      </Banner.Description>
      <Banner.Actions>
        <Banner.ActionPrimary
          href="https://schedule.opendock.com/register&utm_source=shipperguide"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            track('Opened: Opendock Sign Up')
          }}
        >
          Sign up in Opendock
        </Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  )
}
